export enum ControlFlowType {
  CONTINUE = 'Continue',
  BREAK = 'Break'
}

export class ControlFlow<O> {
  private constructor(
    public type: ControlFlowType,
    private _value?: O
  ) {}

  static continue<O>(): ControlFlow<O> {
    return new ControlFlow<O>(ControlFlowType.CONTINUE);
  }

  static break<O>(value: O): ControlFlow<O> {
    return new ControlFlow<O>(ControlFlowType.BREAK, value);
  }

  get isContinue(): boolean {
    return this.type === ControlFlowType.CONTINUE;
  }

  get isBreak(): boolean {
    return this.type === ControlFlowType.BREAK;
  }

  get value(): O {
    if (this._value === undefined) {
      throw new Error('ControlFlow has no value');
    }
    return this._value;
  }
}
